var React = require('react');

function PoundCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#737680","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z","key":0}),React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M8.174 11.522h4.782M10.565 12.956c0 1.585-.327 3.348-1.913 3.348h5.74M14.392 8.652c0-1.055-.857-1.913-1.913-1.913-1.057 0-1.914.858-1.914 1.913v4.304","key":1})]);
}

PoundCircle.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = PoundCircle;

PoundCircle.default = PoundCircle;
